import { useLocation } from "react-router-dom";

export type UserListRouteIntent = {
  targetUserId: number;
  openUserDocuments: boolean;
};

export function useUserListRouteIntent(): UserListRouteIntent {
  const location = useLocation();
  const state = location.state as { targetUserId?: number; openUserDocuments?: boolean } | null;

  return {
    targetUserId: Number(state?.targetUserId ?? 0),
    openUserDocuments: Boolean(state?.openUserDocuments),
  };
}
